"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlyoutContext = void 0;

var _react = require("react");

var _constants = require("./constants");

var FlyoutContext = /*#__PURE__*/(0, _react.createContext)({
  isInFlyout: false,
  flyoutRef: null,
  flyoutTitleId: _constants.FLYOUT_TITLE_ID
});
exports.FlyoutContext = FlyoutContext;
FlyoutContext.displayName = 'FlyoutContext';